import { alpha, Divider, styled } from '@mui/material';
import { FONT_DISPLAY } from 'themes/tokens';

const AVATAR_SIZE = 36;

export const AvatarButton = styled('button')(({ theme }) => ({
  display: 'grid',
  placeItems: 'center',
  flex: `0 0 ${AVATAR_SIZE}px`,
  alignSelf: 'center',
  boxSizing: 'border-box',
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  aspectRatio: '1 / 1',
  padding: 0,
  marginLeft: theme.spacing(1),
  borderRadius: '11px',
  border: `1px solid ${alpha(theme.palette.accent.main, 0.45)}`,
  backgroundColor: alpha(theme.palette.accent.main, 0.14),
  color: theme.palette.text.primary,
  font: 'inherit',
  fontFamily: FONT_DISPLAY,
  fontSize: '0.8rem',
  fontWeight: 700,
  cursor: 'pointer',
  transition: theme.transitions.create(['background-color', 'border-color']),
  '&:hover': {
    borderColor: theme.palette.accent.main,
    backgroundColor: alpha(theme.palette.accent.main, 0.24),
  },
}));

export const AvatarDivider = styled(Divider)(({ theme }) => ({
  '&.MuiDivider-vertical': {
    height: 24,
    alignSelf: 'center',
    margin: theme.spacing(0, 0.5, 0, 1.5),
    borderColor: theme.palette.divider,
  },
}));

export const MenuIdentity = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  padding: theme.spacing(1, 2, 1.5),
  minWidth: 200,
}));
